import { useState } from "react";
import { Check, Pencil, Plus, X } from "lucide-react";
import { Input } from "@/components/ui/input";

export default function RoomTabs({ rooms, active, onSelect, editable, onAdd, onRename, onDelete }) {
  const [editing, setEditing] = useState(null);
  const [name, setName] = useState("");
  return (
    <div className="flex flex-wrap items-center gap-1.5" role="tablist" aria-label="Rooms">
      {rooms.map((r) => editing === r.id ? (
        <form key={r.id} onSubmit={(e) => { e.preventDefault(); onRename(r.id, name || r.name); setEditing(null); }} className="flex items-center gap-1">
          <Input autoFocus value={name} onChange={(e) => setName(e.target.value)} className="h-8 w-36" data-testid="room-rename-input" />
          <button type="submit" aria-label="Save room name" data-testid="room-rename-save"><Check className="h-4 w-4" /></button>
        </form>
      ) : (
        <div key={r.id} className={`group flex items-center rounded-full border text-sm transition-colors ${active === r.id ? "border-primary bg-primary text-primary-foreground" : "hover:bg-secondary"}`}>
          <button role="tab" aria-selected={active === r.id} onClick={() => onSelect(r.id)} className="px-4 py-1.5" data-testid={`room-tab-${r.id}`}>{r.name}</button>
          {editable && active === r.id && (
            <span className="flex items-center gap-1 pr-2">
              <button aria-label="Rename room" onClick={() => { setEditing(r.id); setName(r.name); }} data-testid="room-rename-button"><Pencil className="h-3 w-3" /></button>
              {rooms.length > 1 && <button aria-label="Delete room" onClick={() => onDelete(r.id)} data-testid="room-delete-button"><X className="h-3.5 w-3.5" /></button>}
            </span>
          )}
        </div>
      ))}
      {editable && <button onClick={onAdd} className="flex items-center gap-1 rounded-full border border-dashed px-3 py-1.5 text-sm text-muted-foreground hover:text-foreground" data-testid="add-room-button"><Plus className="h-3.5 w-3.5" />Room</button>}
    </div>
  );
}
